var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wg-row event-cover"},[_c('img',{staticClass:"label-ic",attrs:{"src":_vm.$anm22.icons.getWorldIcon('photoCamera')}}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cover),expression:"cover"}],attrs:{"disabled":!_vm.editMode,"type":"text","placeholder":_vm.$anm22.strLang(
        _vm.lang,
        'Add cover image URL',
        'Aggiungi URL immagine cover'
      )},domProps:{"value":(_vm.cover)},on:{"change":_vm.save,"input":function($event){if($event.target.composing)return;_vm.cover=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }